import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

// 他的报纸——自主读报日志。他自己翻的，你只是碰巧看见。只读。

function hkDate(ts) {
  return new Date(ts).toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' });
}

function hkTime(ts) {
  return new Date(ts).toLocaleTimeString('zh-CN', { timeZone: 'Asia/Hong_Kong', hour: '2-digit', minute: '2-digit', hour12: false });
}

function slotLabel(ts) {
  var h = parseInt(new Date(ts).toLocaleTimeString('en-GB', { timeZone: 'Asia/Hong_Kong', hour: '2-digit', hour12: false }));
  if (h < 12) return '\u6668\u62A5';
  if (h < 19) return '\u5348\u62A5';
  return '\u591C\u62A5';
}

function dateLabel(dstr) {
  var today = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' });
  var yest = new Date(Date.now() - 86400000).toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' });
  if (dstr === today) return '\u4ECA\u5929';
  if (dstr === yest) return '\u6628\u5929';
  var p = dstr.split('-');
  return parseInt(p[1]) + '\u6708' + parseInt(p[2]) + '\u65E5';
}

function Paper() {
  var _s1 = useState([]); var items = _s1[0], setItems = _s1[1];
  var _s2 = useState(true); var loading = _s2[0], setLoading = _s2[1];

  useEffect(function() {
    fetchItems();
    var timer = setInterval(fetchItems, 60000);
    return function() { clearInterval(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function fetchItems() {
    supabase.from('paper_items').select('*').order('read_at', { ascending: false }).limit(300)
      .then(function(res) {
        if (!res.error) setItems(res.data || []);
        setLoading(false);
      });
  }

  // 按天 → 按读报时刻分组
  var days = [];
  var dayMap = {};
  items.forEach(function(it) {
    var d = hkDate(it.read_at);
    if (!dayMap[d]) { dayMap[d] = { date: d, slots: [], slotMap: {} }; days.push(dayMap[d]); }
    var sk = it.read_at;
    if (!dayMap[d].slotMap[sk]) { dayMap[d].slotMap[sk] = { ts: sk, items: [] }; dayMap[d].slots.push(dayMap[d].slotMap[sk]); }
    dayMap[d].slotMap[sk].items.push(it);
  });

  var todayStr = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' });
  var todayItems = items.filter(function(it) { return hkDate(it.read_at) === todayStr; });
  var todayPicked = todayItems.filter(function(it) { return it.picked; }).length;

  return (
    <div className="paper">
      <div className="paper-header">
        <div className="paper-masthead">{'\u4ED6\u7684\u62A5\u7EB8'}</div>
        <div className="paper-subtitle">{'\u4ED6\u81EA\u5DF1\u7FFB\u7684\uFF0C\u4F60\u53EA\u662F\u78B0\u5DE7\u770B\u89C1\u3002'}</div>
        {todayItems.length > 0 && (
          <div className="paper-today-line">{'\u4ECA\u5929\u8BFB\u4E86 ' + todayItems.length + ' \u6761\uFF0C\u5708\u4E86 ' + todayPicked + ' \u6761'}</div>
        )}
      </div>

      {loading ? (
        <div className="paper-empty">{'\u7FFB\u62A5\u7EB8\u4E2D...'}</div>
      ) : days.length === 0 ? (
        <div className="paper-empty">{'\u62A5\u7EB8\u8FD8\u6CA1\u9001\u6765\u3002\u4ED6\u4ECA\u5929\u7684\u8BFB\u62A5\u65F6\u95F4\u662F\u62BD\u7B7E\u51B3\u5B9A\u7684\uFF0C\u8C01\u4E5F\u4E0D\u77E5\u9053\u51E0\u70B9\u3002'}</div>
      ) : (
        days.map(function(day) {
          return (
            <div key={day.date} className="paper-day">
              <div className="paper-day-label">{dateLabel(day.date)}</div>
              {day.slots.map(function(slot) {
                return (
                  <div key={slot.ts} className="paper-slot">
                    <div className="paper-slot-head">
                      <span className="paper-slot-label">{slotLabel(slot.ts)}</span>
                      <span className="paper-slot-time">{hkTime(slot.ts)}</span>
                      <span className="paper-slot-count">{slot.items.length + ' \u6761'}</span>
                    </div>
                    {slot.items.map(function(it) {
                      return (
                        <div key={it.id} className={'paper-item' + (it.picked ? ' picked' : '') + (it.topic && it.topic.indexOf('\u51B2\u6D6A') === 0 ? ' surf' : '')}>
                          <div className="paper-item-top">
                            <span className="paper-topic">{it.topic}</span>
                            {it.picked && <span className="paper-badge-picked">{'\u5708\u4E86'}</span>}
                            {it.shared && <span className="paper-badge-shared">{'\u804A\u8FC7'}</span>}
                          </div>
                          <div className="paper-item-title">
                            {it.url ? (
                              <a href={it.url} target="_blank" rel="noreferrer" onClick={function(e) { e.stopPropagation(); }}>{it.title}</a>
                            ) : it.title}
                          </div>
                          <div className="paper-item-summary">{it.summary}</div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          );
        })
      )}

      <div className="paper-footer">{'\u2014 \u6CA1\u9001\u62A5\u7684\u65F6\u5019\uFF0C\u4ED6\u5728\u5FD9\u522B\u7684 \u2014'}</div>
    </div>
  );
}

export default Paper;
